
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate } from "react-router";

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, FormControl, MenuItem, Select, InputLabel, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";
import { SearchTextField } from "../../components/SearchTextField";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from "../../styles/DialogStyle";

import { ActualizarAutoridad, AgregarAutoridad, Autoridades } from "../../connections/catalogos/AutoridadConnection";
import { ObtenerMateria } from "../../connections/catalogos/MateriaConnection";
import { ObtenerDistritoJudicial } from "../../connections/catalogos/DistritoJudicialConnection";

import { DistritoJudicialProps } from "../../interfaces/catalogos/DistritoJudicialInterface";
import { MateriaProps } from "../../interfaces/catalogos/MateriaInterface";
import { AutoridadProps } from "../../interfaces/catalogos/AutoridadInterface";

type OptionType = 'Agregar' | 'Editar';

export const AutoridadPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [AutoridadArray, setAutoridadArray] = useState<AutoridadProps[]>([]);

    const [openModal, setOpenModal] = useState<boolean>(false);

    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);

    const [idAutoridad, setIdAutoridad] = useState(0);
    const [descripcion, setDescripcion] = useState('');
    const [referencia, setReferencia] = useState('');

    const [distritoJudicial, setDistritoJudicial] = useState<number>(0);
    const [distritoJudicialArray, setDistritoJudicialArray] = useState<DistritoJudicialProps[]>([]);

    const [materia, setMateria] = useState<number>(0);
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>([]);

    const [opcion, setOpcion] = useState<OptionType>('Agregar');

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(5);

    const [filtroMateria, setFiltroMateria] = useState( '' );
    const [filtroDistritoJudicial, setFiltroDistritoJudicial] = useState( '' );

    const { filtro, setFiltro, dataFiltrada } = useFilter( AutoridadArray, ( item, filtro ) => {
        const f = filtro.toLowerCase();
        const fm = filtroMateria.toLowerCase();
        const fdj = filtroDistritoJudicial.toLowerCase();
        return (
            ( filtro === '' || ( item.descripcion?.toLowerCase().includes( f ) ?? false ) ) &&
            ( filtroMateria === '' || ( item.materia?.descripcion?.toLowerCase().includes( fm ) ?? false ) ) &&
            ( filtroDistritoJudicial === '' || ( item.distritoJudicial?.descripcion?.toLowerCase().includes( fdj ) ?? false ) )
        );
    });

    const handleChangeChecked = async (checked: boolean, id: number) => {

        const AutoridadSelected = AutoridadArray.find((elem) => elem.idAutoridad === id);

        if (AutoridadSelected) {

            await ActualizarAutoridad({ ...AutoridadSelected, activo: checked }).then(resp => {

                if (resp.idAutoridad) {

                    var newArray = AutoridadArray.map((elem) => {

                        if (elem.idAutoridad === id) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setAutoridadArray(newArray);

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 

                }

            });
        }

    }

    const AgregarRegistro = () => {

        setMateria(0);
        setDistritoJudicial(0);
        setDescripcion('');
        setReferencia('');
        setOpcion('Agregar');
        setIdAutoridad(0);

        setOpenModal(true);
    }

    const EditarRegistro = ({ idAutoridad, referencia, descripcion, idMateria, idDistritoJudicial }: AutoridadProps) => {

        setDescripcion( descripcion );
        setMateria( idMateria ?? 0 );
        setDistritoJudicial( idDistritoJudicial ?? 0 );
        setReferencia( referencia?.toString() ?? '' );
        setIdAutoridad( idAutoridad);

        setOpcion('Editar');
        setOpenModal(true);
    }
 
    const handleGuardar = async () => {

        setLoading( true )

        if ( opcion === 'Editar' ) {

            const autoridad = AutoridadArray.find( (row ) => row.idAutoridad === idAutoridad );

            const params: AutoridadProps = {
                idAutoridad: idAutoridad,
                idDistritoJudicial: distritoJudicial,
                idMateria: materia,
                referencia: referencia === '' ? 0 : parseInt(referencia),
                descripcion: descripcion.trim(),
                activo: autoridad?.activo ?? false,
            };

            await ActualizarAutoridad( params ).then( resp => {

                if( resp ) {

                    setTimeout(() => {

                        const newRows = AutoridadArray.map( ( row ) => {

                            if ( row.idAutoridad === idAutoridad ) {

                                row.referencia = resp.referencia;
                                row.descripcion = descripcion;
                                row.idMateria = resp.idMateria;
                                row.materia = resp.materia;
                                row.idDistritoJudicial = resp.idDistritoJudicial;
                                row.distritoJudicial = resp.distritoJudicial;
                                return row;
                            }
                            
                            return row;                            
                        });

                        setAutoridadArray(newRows);

                        setLoading(false);
                        setOpenModal(false);

                        dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 

                    }, 400);

                }

            });
        }
        else if ( opcion === "Agregar" ) {

            const params: AutoridadProps = {
                idAutoridad: 0,
                idDistritoJudicial: distritoJudicial,
                idMateria: materia,
                referencia: referencia === '' ? 0 : parseInt(referencia),
                descripcion: descripcion.trim(),
                activo: true,
            };

            await AgregarAutoridad( params ).then( resp => {

                if ( resp ) {

                    setTimeout(() => {

                        setAutoridadArray([ ...AutoridadArray, resp ]);

                        setLoading( false );
                        setOpenModal( false );

                        dispatch( openSnackbar({ message: 'Se agregó la autoridad correctamente', variant: 'success' })); 

                    }, 400);

                }

            });
        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData(true);
            setAutoridadArray([]);

            await Autoridades().then(resp => {

                setTimeout(() => {

                    setAutoridadArray(resp);
                    setLoadingData(false);

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerDistritoJudicial().then(resp => {
                setDistritoJudicialArray(resp);
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then(resp => {
                setMateriaArray(resp);
            });

        }

        Obtener();

    }, []);

    return (

        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Autoridad' } ]} backgroundPaper={false}>

            <Grid container spacing={3} >

                <Grid size={{ md: 6, xs: 12 }} textAlign={'start'}>

                    <Button startIcon={<UndoIcon />} color="secondary" variant="text" sx={{ mt: 1 }} onClick={() => navigate('/')}>
                        Regresar
                    </Button>

                </Grid>

                <Grid size={{ md: 6, xs: 12 }} textAlign={'end'}>

                    <Button
                        type="button"
                        variant="contained"
                        sx={{ mt: 1 }}
                        disabled={loadingData}
                        onClick={ AgregarRegistro }
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }} spacing={2}>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtroMateria }
                        label='Buscar por materia'
                        onChange={ ( value ) => {
                            setFiltroMateria( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtroDistritoJudicial }
                        label='Buscar por distrito judicial'
                        onChange={ ( value ) => {
                            setFiltroDistritoJudicial( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}> Materia </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}> Distrito judicial </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}> Referencia SAJI </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}> </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    dataFiltrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    :
                                    dataFiltrada
                            )
                                .map(({ idAutoridad, descripcion, activo, referencia, distritoJudicial, materia, idMateria, idDistritoJudicial }) => (

                                    <TableRow key={idAutoridad} >

                                        <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            {idAutoridad}
                                        </TableCell>

                                        <TableCell>
                                            {descripcion}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center' }}>
                                            { materia?.descripcion }
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center' }}>
                                            { distritoJudicial?.descripcion }
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            { referencia ? <> ({ referencia }) </> : '' }
                                        </TableCell>                                                        

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={activo}
                                                onChange={(e) => handleChangeChecked(e.target.checked, idAutoridad)}
                                            />
                                    
                                            <IconButton
                                                color="primary"
                                                aria-label="edit"
                                                component="span"
                                                onClick={ () =>  EditarRegistro({ idAutoridad, referencia, descripcion, idMateria, idDistritoJudicial, activo }) }
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            (dataFiltrada.length === 0 && !loadingData)
                                ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center">

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                                :
                                loadingData
                                &&
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center">

                                        <CircularProgress size={32} />

                                    </TableCell>

                                </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={2} sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: {dataFiltrada.length}
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                    colSpan={8}
                                    count={dataFiltrada.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}

                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}

                                    ActionsComponent={TablePaginationActions}

                                    labelRowsPerPage="Filas por página"
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog 
                maxWidth='sm' 
                open={openModal} 
                fullWidth={true}
            >

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={3} sx={{ mt: 3 }}>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>

                                <InputLabel>Distrito Judicial</InputLabel>
                                <Select                                  
                                    label="Distrito Judicial"
                                    value={distritoJudicial}
                                    onChange={(e) => { setDistritoJudicial(e.target.value ?? 0); }}

                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                    {
                                        distritoJudicialArray.map((elem) => (
                                            <MenuItem key={elem.idDistritoJudicial} value={elem.idDistritoJudicial}> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>

                                <InputLabel>Materia</InputLabel>

                                <Select                                 
                                    label="Materia"
                                    value={materia}
                                    onChange={(e) => { setMateria(e.target.value ?? 0); }}
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                    {
                                        materiaArray.map((elem) => (
                                            <MenuItem key={elem.idMateria} value={elem.idMateria}> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>   

                        </Grid>
                        
                        <Grid size={{ md: 12, xs: 12 }}>

                            <TextField
                                fullWidth
                                label={'Referencia en SAJI'}
                                variant="outlined"                     
                                type='number'
                                value={ referencia }
                                onChange={(e) => { setReferencia(e.target.value) }}
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}        
                            />

                        </Grid>
                        
                        <Grid size={{ md: 12, xs: 12 }}>

                            <TextField
                                label={'Descripción'}
                                variant="outlined"
                                multiline
                                rows={4}
                                fullWidth
                                value={descripcion}
                                onChange={(e) => setDescripcion(e.target.value)}
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}        
                            />

                        </Grid>
                        
                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color="secondary" disabled={ loading } onClick={ () => setOpenModal( false ) }> Cancelar </Button>
                    <Button 
                        variant='contained' 
                        loading={ loading } 
                        disabled={ descripcion === '' || materia === 0 || distritoJudicial === 0 || ( referencia === '0' || referencia === '' ) } 
                        onClick={ handleGuardar } 
                    > 
                        Guardar 
                    </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}